import templateStr from 'text!./pagination.html';
import _ from 'lodash';
import assert from 'assert';
/**
 * Pagination directive
 *
 * Accepts a loadByOffset method with signature (offsetStart, offsetEnd) -> promise
 * loadByOffset should resolve with pageListData, actual data that would be shown
 *  {number}    pageListData.maxNumberOfResults     Maximum possible number of results for the given query
 *
 * Returned data will be available as pageListData in the transcluded scope
 *
 * @returns {Object}
 */
export default [() => {
    return {
        restrict: 'E',
        template: templateStr,
        transclude: true,
        scope: {
            loadByOffset: '&',
            pageSize: '@',
            pageTitle: '@',
            showWholeList: '=',
            tableTitle: '@'
        },
        link: ($scope, $element) => {
            const pageSize = parseInt($scope.pageSize) || 10;
            $scope.loading = false;
            $scope.pageListData = {};

            $scope.showButtons = () => {
                if ($scope.showWholeList) {
                    return false;
                }

                return $scope.pageListData.items && $scope.pageListData.items.length > 0 && $scope.pageListData.maxNumberOfResults > pageSize;
            };

            initPageData();

            function initPageData() {
                $scope.pageListData = {};

                $scope.pageData = {
                    displayStart: 1,
                    displayEnd: pageSize
                };
            }

            function loadInitData() {
                loadData($scope.pageData.displayStart - 1, $scope.pageData.displayEnd - 1);
            }

            $scope.reload = loadInitData;


            function loadData(offsetStart, offsetEnd) {
                $scope.error = false;
                $scope.loading = true;

                $scope.loadByOffset()(offsetStart, offsetEnd)
                    .then(data => {
                        assert(
                            typeof data === 'object' && typeof data.maxNumberOfResults === 'number',
                            'Expecting a response with maxNumberOfResults key. ' +
                            'It will be available as pageListData in the transcluded scope.'
                        );

                        $scope.pageListData = data;
                        $element.scope().pageListData = data;

                        $scope.pageData.displayEnd = (offsetEnd + 1);
                        $scope.pageData.displayStart = (offsetStart + 1);
                        $scope.loading = false;
                    })
                    .catch(() => {
                        $scope.error = true;
                    });
            }

            $scope.nextPage = () => {
                const offsetEnd = ($scope.pageData.displayEnd + pageSize) > $scope.pageListData.maxNumberOfResults ? $scope.pageListData.maxNumberOfResults - 1 : $scope.pageData.displayEnd + (pageSize - 1);
                const offsetStart = $scope.pageData.displayStart + (pageSize - 1);
                loadData(offsetStart, offsetEnd);
            };

            $scope.previousPage = () => {
                if ($scope.pageData.displayStart !== 1 && !$scope.pageData.displayStart - pageSize < 1) {
                    const offsetStart = ($scope.pageData.displayStart - pageSize) >= 1 ? $scope.pageData.displayStart - pageSize - 1 : 0;
                    const offsetEnd = offsetStart + (pageSize - 1);
                    loadData(offsetStart, offsetEnd);
                }
            };

            const update = function () {
                initPageData();
                loadInitData();
            };

            $scope.$watch('loadByOffset()', update);

            // Don't update when maxNumberOfResults is undefined. Watch should not trigger on initial value (otherwise 2 updates may be run initially).
            $scope.$watch('pageListData.maxNumberOfResults', _.after(2, maxNumberOfResults => maxNumberOfResults && update));
        }
    };
}];